import { useEffect } from 'react';

const ICON_FONT_ID = 'zop-ai-icon-font-cdn';
const BOOTSTRAP_ICONS_VERSION = '1.13.1';

const AIChatbotWidget = () => {
  useEffect(() => {
    // chatbot.hostzop.com serves icon fonts without Access-Control-Allow-Origin,
    // so cross-origin @font-face fails. Register a CORS-safe face the Shadow DOM can use.
    if (!document.getElementById(ICON_FONT_ID)) {
      const style = document.createElement('style');
      style.id = ICON_FONT_ID;
      style.textContent =
        `@font-face{font-display:block;font-family:"bootstrap-icons";src:url("https://cdn.jsdelivr.net/npm/bootstrap-icons@${BOOTSTRAP_ICONS_VERSION}/font/fonts/bootstrap-icons.woff2") format("woff2"),url("https://cdn.jsdelivr.net/npm/bootstrap-icons@${BOOTSTRAP_ICONS_VERSION}/font/fonts/bootstrap-icons.woff") format("woff")}`;
      document.head.appendChild(style);
    }

    const script = document.createElement('script');
    script.src = 'https://chatbot.hostzop.com/main.min.js';
    script.setAttribute('data-api-url', 'https://chatbot.hostzop.com/api');
    script.setAttribute('data-project-id', '6ab0bd9b3c7b54f8df1b4d99');
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
};

export default AIChatbotWidget;